import CustomerTicketDetails from "./CustomerTicketDetails";
import CustomerTicketDetailsProvider from "./CustomerTicketDetailsContext";

let Index = () => {

    return (
        <CustomerTicketDetailsProvider>
            <CustomerTicketDetails />
        </CustomerTicketDetailsProvider>
    );
}


export default Index;